export default function WarningCircleIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={Math.round((size * 17) / 16)}
        viewBox='0 0 16 17'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.01874 2.02188C7.31826 1.85324 7.6562 1.76465 7.99993 1.76465C8.34367 1.76465 8.6816 1.85324 8.98113 2.02188C9.28065 2.19051 9.53166 2.4335 9.70993 2.72739L9.71185 2.73056L15.3585 12.1572L15.3639 12.1664C15.5386 12.4689 15.631 12.8117 15.6319 13.161C15.6329 13.5102 15.5424 13.8536 15.3695 14.157C15.1966 14.4604 14.9472 14.7132 14.6462 14.8903C14.3452 15.0674 14.0031 15.1626 13.6539 15.1664L13.6466 15.1665L2.34594 15.1665C1.99674 15.1626 1.65463 15.0674 1.35365 14.8903C1.05266 14.7132 0.803301 14.4604 0.630365 14.157C0.45743 13.8536 0.36695 13.5102 0.367928 13.161C0.368906 12.8117 0.461307 12.4689 0.635939 12.1664L0.641354 12.1572L6.28992 2.72739C6.46819 2.43349 6.71921 2.19051 7.01874 2.02188ZM7.99993 3.09798C7.88535 3.09798 7.77271 3.12751 7.67287 3.18372C7.57348 3.23968 7.49011 3.3202 7.43074 3.41757L1.78839 12.837C1.73161 12.9369 1.70158 13.0498 1.70126 13.1647C1.70093 13.2811 1.73109 13.3956 1.78874 13.4967C1.84638 13.5978 1.9295 13.6821 2.02983 13.7411C2.12928 13.7997 2.2422 13.8313 2.35753 13.8331H13.6423C13.7577 13.8313 13.8706 13.7997 13.97 13.7411C14.0704 13.6821 14.1535 13.5978 14.2111 13.4967C14.2688 13.3956 14.2989 13.2811 14.2986 13.1647C14.2983 13.0498 14.2683 12.9369 14.2115 12.8371L8.56993 3.4189C8.56966 3.41845 8.5694 3.41801 8.56913 3.41757C8.50975 3.3202 8.42639 3.23968 8.327 3.18372C8.22716 3.12751 8.11451 3.09798 7.99993 3.09798Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.99992 5.83301C8.36811 5.83301 8.66659 6.13148 8.66659 6.49967V9.16634C8.66659 9.53453 8.36811 9.83301 7.99992 9.83301C7.63173 9.83301 7.33325 9.53453 7.33325 9.16634V6.49967C7.33325 6.13148 7.63173 5.83301 7.99992 5.83301Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.33325 11.8337C7.33325 11.4655 7.63173 11.167 7.99992 11.167H8.00659C8.37477 11.167 8.67325 11.4655 8.67325 11.8337C8.67325 12.2018 8.37477 12.5003 8.00659 12.5003H7.99992C7.63173 12.5003 7.33325 12.2018 7.33325 11.8337Z'
        />
      </svg>
    </span>
  );
}
